<!-- MFITTの空席照会で、列車が見つからなかった場合 -->
<template>
  <ItemDialog ref="notExitTrain" image-type="alert">
    <template #content-area>
      <h2>予約可能な列車がありません</h2>
      <p class="text-center">条件を変更してお試しください。</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogNotExitTrain",
  setup() {
    const notExitTrain = ref(null);

    const openDialog = () => {
      notExitTrain.value.open();
    };

    const closeDialog = () => {
      notExitTrain.value.close();
    };

    return {
      notExitTrain,
      openDialog,
      closeDialog,
    };
  },
};
</script>
